export default __webpack_public_path__ + "static/media/1x2.64e74084.jpg";